define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var Engagements = require('web-agent-assets-js/lpEngagements');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var lpEngagementsController = function (model, config) {
        this.applicationType = "lpEngagementsController";
        var logger = WebAgentLogger.getLogger(this.applicationType);
        //get the enum
        var offsiteEnum = null;
        require(["assets/data/sharedData/engagementSourceEnum.json"], function(engagementSourceEnum) {
            offsiteEnum = engagementSourceEnum.ENGAGEMENT_SOURCE;
            offsiteEnum = _.invert(offsiteEnum);
        });

        var engagementsApi, getWindow, windowContext;

        if (config) {
            getWindow = config.getWindow;
            windowContext = config.windowContext;
        }
        this.getEngagement = function (data) {
            data.campId = this.campId;
            getEngagement(data);
        };

        this.getSingleEngagementsObject = function (engagementObject, name) {
            return getSingleEngagementsObject(engagementObject, name);
        };
        initializeApi();

        function initializeApi() {
            engagementsApi = new Engagements();

        }

        /////////////////////////////// Engagement DATA ///////////////////////////////////

        function getEngagement(data) {
            logger.info("","getEngagement", data);
            var id,  campId;
            if (data) {
                id = data.id;
                campId = data.campId;
            }
            if (id) {
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleEngagementsSuccess, data),
                    error: lpUtils.callbackContextWrapper(handleEngagementsError, data),
                    context: data
                };
                engagementsApi.getEngagement(requestObj, id, campId);
            }
        }

        function handleEngagementsSuccess(data) {
            logger.info("engagements return as Success", "handleEngagementsSuccess");
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpEngagementsController.prototype.handleACRequestSuccess(model, data, lpEngagementsController.prototype.serviceNames.engagements, getSingleEngagementsObject, context, dataObject);
        }

        function handleEngagementsError(data) {
            logger.error("", "handleEngagementsError", data);
            logger.graph({name: 'handleEngagementsError'});
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpEngagementsController.prototype.handleRequestError(model, data, lpEngagementsController.prototype.serviceNames.engagements, data && data.visitorId, dataObject);
        }

        function getSingleEngagementsObject(engagementObject, name) {
            var sourceName = '';//(engagementObject.source && engagementObject.source.name) || "";

            var toReturn = lpEngagementsController.prototype.getDataFromModelIfNotModified(model, this, name) || {
                id : engagementObject.id,
                agentNote : engagementObject.agentNote,
                windowId : engagementObject.windowId,
                name: engagementObject.name,
                source: {
                    id: engagementObject.appInstallationId ? engagementObject.appInstallationId : engagementObject.source
                },
                skillId: engagementObject.skillId,
                skillName: engagementObject.skillName,
                _visitorBehaviorId: engagementObject._visitorBehaviorId || (engagementObject.visitorBehaviors && engagementObject.visitorBehaviors[0]),
                language: engagementObject.language
            };
            if (engagementObject.appInstallationId) {
                toReturn.source.appInstallationId = engagementObject.appInstallationId;
            }
            else if (offsiteEnum && offsiteEnum[engagementObject.source] && agentLEManager.hasLETranslationKey("LEWebAgent.VISIT_INFO_offsite_" + offsiteEnum[engagementObject.source])) {
                toReturn.source.name = agentLEManager.translateLE("LEWebAgent.VISIT_INFO_offsite_" + offsiteEnum[engagementObject.source]);
            }
            var visitorId = engagementObject.visitorId || (engagementObject.dataObject && engagementObject.dataObject.data && engagementObject.dataObject.data.visitorId);
            if(getWindow && toReturn.windowId){
                lpEngagementsController.prototype.addServiceToRequestedServices(lpEngagementsController.prototype.serviceNames.window, engagementObject.dataObject, model);
                getWindow.call(windowContext || {}, {id: toReturn.windowId, visitorId:visitorId, dataObject:engagementObject.dataObject});
                lpEngagementsController.prototype.addDataObjectToVisitorInfo(model, {visitorId: visitorId, window:{id: toReturn.windowId}}, undefined, engagementObject.dataObject);
            }
            lpEngagementsController.prototype.addToVisitorInfoById(model, 'engagement', toReturn, visitorId, engagementObject && engagementObject.dataObject, lpEngagementsController.prototype.serviceNames.engagements);

            return toReturn;
        }
    };
    lpEngagementsController.prototype = new lpBaseInfoController();

    return lpEngagementsController;

});
